import React from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { SMS_ON_SUCCESS_PAY_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { usePageMessages, useExtra } from 'apps/auth/hooks/selectors';

import SendSMS from './GaSendSMS';

const GaStatusSuccess = (props) => {
    const { headerTitle, statusSmsTitle, statusDoneTitle } = usePageMessages();
    const { pocketId } = useExtra();
    return (
        <InfoPage
            animatedIconSuccess
            headerText={headerTitle}
            buttonRowCaption={props.smsOnSuccessPay && !props.smsOnSuccessPay.sended && props.showSendSMSNotificationBlock ? statusSmsTitle : null}
            buttonRowOnClick={() => props.toggleModal(true, <SendSMS formName={SMS_ON_SUCCESS_PAY_FORM_NAME} />)}
            primaryButtonCaption={statusDoneTitle}
            primaryButtonType="link"
            primaryButtonLink={`${AUTH_GA_POCKET}${pocketId}`}
        />
    );
};

export default connect(null, { toggleModal })(GaStatusSuccess);
